/**
 * Created by pajicv on 10/8/18.
 */
import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TaskButton from './TaskButton.enhancer';

const objectToArray = (obj, orderBy) => Object.keys(obj).sort((key1, key2) => {
    if(!orderBy || orderBy !== 'date') {
        return obj[key1].index - obj[key2].index;
    } else {
        if(!obj[key1].dueDate){
            return 1;
        }
        else if(!obj[key2].dueDate){
            return -1;
        }
        else {
            return new Date(obj[key1].dueDate).getTime() - new Date(obj[key2].dueDate).getTime();
        }
    }

}).map(key => ({ id: key, active: obj[key].active }));

const arrayToObject = arr => arr.reduce((acc, item, index) => { acc[item.id] = { index, active: item.active }; return acc; }, {});

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? '#ccc' : '#fff',

    // styles we need to apply on draggables
    ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#fff' : '#fff',
    padding: grid,
    width: '96%',
    marginLeft: '0%'
});

class CycleTasks extends Component {

    onDragEnd = (result, items) => {
        const { phase, onTaskReorder, orderBy } = this.props;
        // dropped outside the list

        if(orderBy === 'date') {
            return;
        }

        if (!result.destination) {
            return;
        }

        const ordered = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        onTaskReorder(phase, arrayToObject(ordered));

    };

    handleDueDateChange = (taskId, dueDate) => {
        const { onTaskDueDateChange, phase } = this.props;
        onTaskDueDateChange(phase, taskId, dueDate);
    };

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        const { tasks, onTaskClick, onTaskRemove, subTaskAssigned, orderBy, onActiveTaskToggle } = this.props;
        const items = objectToArray(tasks, orderBy);
        return (
            <DragDropContext onDragEnd={(result) => this.onDragEnd(result, items)}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {items.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                            <TaskButton
                                                id={item.id}
                                                key={item.id}
                                                onTaskClick={onTaskClick}
                                                onTaskRemove={onTaskRemove}
                                                subTaskAssigned={subTaskAssigned}
                                                onDueDateChange={this.handleDueDateChange}
                                                onActiveTaskToggle={onActiveTaskToggle}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
}

export default CycleTasks;



// WEBPACK FOOTER //
// ./src/components/common/CycleTasks.js